import frogJump from './stateless/frog-jump';
import diveDown from './stateless/dive-down';
import diveDownDeep from './stateless/dive-down-deep';
import helicopter from './stateless/helicopter';
import highHelicopter from './stateless/high-helicopter';
import magicC from './stateless/magic-c';
import slideDown from './stateless/slide-down';
import slideDownReversed from './stateless/slide-down-reversed';
import karateKick from './stateless/karate-kick';
import slideAway from './stateless/slide-away';
import baseball from './stateless/baseball';
import bump from './stateless/bump';
import bumpInner from './stateless/bump-inner';
import swim from './stateless/swim';
import smile from './stateless/smile';
import firefighter from './stateless/firefighter';
import jet from './stateless/jet';
import tow from './stateless/tow';
import LongSwim from './long-swim';

const AnimationFunctions = {
  frogJump,
  diveDown,
  diveDownDeep,
  helicopter,
  highHelicopter,
  magicC,
  slideDown,
  slideDownReversed,
  karateKick,
  slideAway,
  baseball,
  bump,
  bumpInner,
  swim,
  smile,
  firefighter,
  jet,
  tow,
  longSwim: new LongSwim(),
};

export default AnimationFunctions;
